export default __webpack_public_path__ + "static/media/Tv-documentation.39f1de33.md";